var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowStockIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20213_32427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 14.896V8.80225",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2713 1.49633C10.44 1.40204 10.6299 1.35254 10.8231 1.35254C11.0163 1.35254 11.2063 1.40204 11.375 1.49633L14.2187 3.09425C14.4201 3.20814 14.5877 3.37345 14.7042 3.57331C14.8208 3.77316 14.8823 4.00038 14.8823 4.23175C14.8823 4.46312 14.8208 4.69034 14.7042 4.89019C14.5877 5.09005 14.4201 5.25536 14.2187 5.36925L5.97184 10.014C5.80271 10.1105 5.61135 10.1613 5.41663 10.1613C5.22192 10.1613 5.03056 10.1105 4.86143 10.014L2.03122 8.41613C1.82982 8.30224 1.66227 8.13692 1.54569 7.93707C1.42911 7.73722 1.36768 7.51 1.36768 7.27863C1.36768 7.04726 1.42911 6.82003 1.54569 6.62018C1.66227 6.42033 1.82982 6.25501 2.03122 6.14113L10.2713 1.49633Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 8.80225V11.4226C13.5419 11.6781 13.4719 11.9288 13.3394 12.1474C13.2068 12.3659 13.0168 12.5438 12.79 12.6616L8.72752 14.747C8.54139 14.8438 8.33469 14.8943 8.12492 14.8943C7.91515 14.8943 7.70845 14.8438 7.52232 14.747L3.45982 12.6616C3.23305 12.5438 3.04302 12.3659 2.91048 12.1474C2.77794 11.9288 2.70799 11.6781 2.70825 11.4226V8.80225",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2187 8.41616C14.4201 8.30227 14.5877 8.13695 14.7042 7.9371C14.8208 7.73725 14.8823 7.51003 14.8823 7.27866C14.8823 7.04729 14.8208 6.82007 14.7042 6.62021C14.5877 6.42036 14.4201 6.25504 14.2187 6.14116L5.97861 1.48959C5.81062 1.39339 5.62039 1.34277 5.42679 1.34277C5.2332 1.34277 5.04296 1.39339 4.87497 1.48959L2.03122 3.09428C1.82982 3.20817 1.66227 3.37349 1.54569 3.57334C1.42911 3.77319 1.36768 4.00041 1.36768 4.23178C1.36768 4.46315 1.42911 4.69037 1.54569 4.89023C1.66227 5.09008 1.82982 5.25539 2.03122 5.36928L10.2781 10.0141C10.446 10.1105 10.6363 10.1613 10.8299 10.1613C11.0236 10.1613 11.2138 10.1105 11.3817 10.0141L14.2187 8.41616Z",
    stroke: "#00C49A",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20213_32427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.25,
    height: 16.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowStockIcon);
export default __webpack_public_path__ + "static/media/low-stock-icon.581dd681bf408aa4205d242abe17187a.svg";
export { ForwardRef as ReactComponent };